import { type ReactNode, type SubmitEventHandler } from 'react';
import { FormStatusOverlay } from './form-status-overlay';

type OverlayMessages = {
  closeLabel?: string;
  errorMessage?: string;
  errorTitle?: string;
  successTitle?: string;
  successMessage?: string;
};

type FormLayoutProps = Readonly<{
  status: 'idle' | 'success' | 'error';
  onOverlayClose: () => void;
  overlayMessages: OverlayMessages;
  requiredFieldNote?: string;
  footerNote?: string;
  className?: string;
  onSubmit: SubmitEventHandler<HTMLFormElement>;
  children: ReactNode;
}>;

export function FormLayout({
  status,
  onOverlayClose,
  overlayMessages,
  requiredFieldNote,
  footerNote,
  onSubmit,
  children,
}: FormLayoutProps) {
  return (
    <div className="bg-secondary relative flex flex-col items-center gap-8 overflow-hidden p-[2.5rem] md:p-10">
      <FormStatusOverlay {...overlayMessages} onClose={onOverlayClose} status={status} />
      <p className="br-type-body-sm text-center text-[hsl(var(--colors-primary))]">
        {requiredFieldNote ?? '*Indicates required field'}
      </p>
      <form className="flex w-full flex-col items-center gap-8" onSubmit={onSubmit}>
        {children}
      </form>
      {footerNote ? (
        <p className="br-type-body-sm text-center text-[hsl(var(--colors-primary))]">
          {footerNote}
        </p>
      ) : null}
    </div>
  );
}
